import { Component } from '@angular/core';
import { LoginService } from '../shared/services/login.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from '../shared/translate.directive';
import { Router } from '@angular/router';
import { ErrorComponent } from '../shared/error/error.component';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule,FormsModule,TranslateDirective, ErrorComponent],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.less'
})
export class ChangePasswordComponent {
  constructor(private service: LoginService, private router: Router){
  }

  model:any={
    Email:null,
    OldPassword:null,
    NewPassword:null,
    ConfirmPassword:null
  }
  successfulReg=false;
  hasErrors=false;
  errors:any = {};
  ngOnInit(){

  }

  changePassword(){
    this.successfulReg = false;
    this.hasErrors = false;
    this.errors = null;

    this.service.changePassword(this.model).subscribe({
      next: res =>{
        this.successfulReg=true;
        this.errors = null;
        this.hasErrors=false;
      },
      error: err=>{    
        this.hasErrors=true;
        this.errors=err?.error?.errors || err?.error || err;
      }
    })
  }

  redirect(){
    this.router.navigate(['/login']);
  }
}
